import { Component, Host, h, Prop } from "@stencil/core";

import { Layout } from "../../index";

/**
 * @slot - Slot for `stzh-cell` elements
 */
@Component({
  tag: "stzh-row",
  styleUrl: "stzh-row.scss",
  shadow: true,
})
export class StzhRow {
  /** Default span of each cell */
  @Prop({ reflect: true }) span: number;
  /** Default span of each cell above small breakpoint */
  @Prop({ reflect: true }) spanSmall: number;
  /** Default span of each cell above medium breakpoint */
  @Prop({ reflect: true }) spanMedium: number;
  /** Default span of each cell above large breakpoint */
  @Prop({ reflect: true }) spanLarge: number;
  /** Default span of each cell above ultra breakpoint */
  @Prop({ reflect: true }) spanUltra: number;

  /** Controlling how cells are positioned along a container's main axis */
  @Prop({ reflect: true }) justify: Layout.Justify = "start";

  /** Control how cells items are positioned along a container's cross axis */
  @Prop({ reflect: true }) items: Layout.Items = "start";

  /** Utilities for controlling how rows are positioned in multi-row flex containers. */
  @Prop({ reflect: true }) content: Layout.Justify = "start";

  render() {
    return (
      <Host>
        <div
          class={{
            "stzh-row": true,
            [`stzh-row--justify-${this.justify}`]: !!this.justify,
            [`stzh-row--items-${this.items}`]: !!this.items,
            [`stzh-row--content-${this.content}`]: !!this.content,
          }}
        >
          <slot></slot>
        </div>
      </Host>
    );
  }
}
